/* eslint-disable  jsx-a11y/click-events-have-key-events  */
/* eslint-disable jsx-a11y/role-has-required-aria-props */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import Divider from '@material-ui/core/Divider';
import { ReactComponent as Language } from '../../../assets/icons/globe.svg';
import * as Constant from '../../../constants/actionTypes';
import techConfig from '../../../techConfig';
import { firstLowerLetter, labelName, onAddInertToDrawer } from '../../UtilsWeb';
import styles from './styles';

const DrawerList = ({ redirect, route, classes, onlyIcons, intl, toggleDrawer }) => {
  const { WebVersionNumber } = techConfig;
  const listItemHighlight = routName => {
    return route === routName
      ? {
          root: classes.root,
        }
      : {};
  };
  // if (route.includes(`${Constant.SLASH}${firstLowerLetter(Constant.PROVIDER_CARD_LINK)}`)) {
  //   return (
  //     <div
  //       id={
  //         onlyIcons ? `${Constant.LABEL_LANGUAGE}-drawerIcon` : `${Constant.LABEL_LANGUAGE}-drawer`
  //       }
  //       role="button"
  //       tabIndex={0}
  //       className={`${classes.listItemPadding} ${classes.drawerRow}`}
  //       onClick={() => {
  //         onAddInertToDrawer('provider-card-template', 'add');
  //         redirect(`${Constant.SLASH}${firstLowerLetter(Constant.LANGUAGE_LINK)}`);
  //       }}
  //       classes={listItemHighlight(`${Constant.SLASH}${firstLowerLetter(Constant.LANGUAGE_LINK)}`)}
  //       aria-label={intl.formatMessage({ id: Constant.LABEL_LANGUAGE })}
  //       onKeyDown={async event => {
  //         if (event?.key === 'Space' || event?.key === 'Enter') {
  //           toggleDrawer(false);
  //           redirect(`${Constant.SLASH}${firstLowerLetter(Constant.LANGUAGE_LINK)}`);
  //         }
  //       }}
  //     >
  //       <>
  //         <Language style={{ width: 30, height: 30 }} />
  //         {!onlyIcons && (
  //           <div
  //             aria-label={intl.formatMessage({ id: Constant.LABEL_LANGUAGE })}
  //             className={classes.centerAlign}
  //           >
  //             {labelName(Constant.LABEL_LANGUAGE)}
  //           </div>
  //         )}
  //       </>
  //     </div>
  //   );
  // }
  return (
    <div role="region" aria-label="Menu">
      <div
        id={Constant.LANGUAGE_LINK}
        key={Constant.LANGUAGE_LINK}
        role="button"
        tabIndex="0"
        className={classes.listItemPadding}
        onClick={() => {
          if (route.includes(`${Constant.SLASH}${firstLowerLetter(Constant.PROVIDER_CARD_LINK)}`)) {
            onAddInertToDrawer('provider-card-template', 'add');
          }
          redirect(`${Constant.SLASH}${firstLowerLetter(Constant.LANGUAGE_LINK)}`);
        }}
        classes={listItemHighlight(`${Constant.SLASH}${firstLowerLetter(Constant.LANGUAGE_LINK)}`)}
        aria-label={intl.formatMessage({ id: Constant.LABEL_LANGUAGE })}
        onKeyDown={event => {
          if (event?.key === 'Space' || event?.key === 'Enter') {
            redirect(`${Constant.SLASH}${firstLowerLetter(Constant.LANGUAGE_LINK)}`);
            toggleDrawer(false);
          }
        }}
      >
        <>
          <Language className={classes.IconsSize} />
          {!onlyIcons && (
            <div
              aria-label={`${intl.formatMessage({
                id: Constant.LABEL_LANGUAGE,
              })}`}
              // lang={locale}
              className={classes.centerAlign}
            >
              {labelName(Constant.LABEL_LANGUAGE)}
            </div>
          )}
        </>
      </div>
      <Divider style={{ marginBottom: 20 }} />
      {!onlyIcons && (
        <div className={classes.versionStyle}>
          <div className={classes.versionStyle1}>{labelName(Constant.LABEL_VERSION_NUMBER)}</div>
          <div className={classes.versionStyle2}>{WebVersionNumber}</div>
        </div>
      )}
    </div>
  );
};

DrawerList.propTypes = {
  redirect: PropTypes.func.isRequired,
  route: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  onlyIcons: PropTypes.bool,
  intl: PropTypes.object.isRequired,
  // locale: PropTypes.string.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
};

DrawerList.defaultProps = {
  onlyIcons: false,
};

export default withStyles(styles)(memo(injectIntl(DrawerList)));
